import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import axios from 'axios';
import Login from './Login';
import apiBaseUrl from './API'

class Register extends Component {
  constructor(props){
    super(props);
    this.state={
      name:'',
      email:'',
      password:'',
      role: ''
    }
  }
  componentWillReceiveProps(nextProps){
    console.log("nextProps",nextProps);
  }
  handleClick(event,role){
   // var apiBaseUrl = "https://hints-app.herokuapp.com/api";
    // console.log("values in register handler",role);
    var self = this;
    //To be done:check for empty values before hitting submit
    if(this.state.name.length>0 && this.state.email.length>0 && this.state.password.length>0){
      console.log("payload ")
      var payload={
     
      "name":this.state.name,
      //"userid":this.state.email,
      "password":this.state.password,
      "email": this.state.email,
      "role":"user",
      "emp_id": this.state.emp_id
      }
      axios.post(apiBaseUrl+'/register', payload)
     .then(function (response) {
       console.log(response);
       if(response.data.code === 200){
        //  console.log("registration successfull");
         var loginscreen=[];
         loginscreen.push(<Login parentContext={this} appContext={self.props.appContext} role={role}/>);
         var loginmessage = "Not Registered yet.Go to registration";
         self.props.parentContext.setState({loginscreen:loginscreen,
         loginmessage:loginmessage,
         buttonLabel:"Register",
         isLogin:true
          });
       }
       else{
         console.log("some error ocurred",response.data.code);
       }
     })
     .catch(function (error) {
       console.log(error);
     });
    }
    else{
      alert("Input field value is missing");
    }

  }
  render() {
    // console.log("props",this.props);
     return (
      <div>
        <MuiThemeProvider>
          <div>
          <AppBar
             title="Register"
           />
            <TextField
             hintText="Enter your EMP ID"
             floatingLabelText="Employee ID"
             onChange = {(event,newValue) => this.setState({emp_id:newValue})}
             />
             <br>
             </br>
          
           <TextField
             hintText="Enter your Name"
             floatingLabelText="Name"
             onChange = {(event,newValue) => this.setState({name:newValue})}
             />
           <br/>
           <TextField
             hintText="Enter your EmailID"
             floatingLabelText="Email ID"
             onChange = {(event,newValue) => this.setState({email:newValue})}
             />
          <br/>
           <TextField
             type = "password"
             hintText="Enter your Password"
             floatingLabelText="Password"
             onChange = {(event,newValue) => this.setState({password:newValue})}
             />
           <br/>
           <RaisedButton label="Submit" primary={true} style={style} onClick={(event) => this.handleClick(event,this.props.role)}/>
          </div>
         </MuiThemeProvider>

         
      </div>
    );
  }
}

const style = {
  margin: 15,
};

export default Register;



// WEBPACK FOOTER //
// ./src/Register.js